import { showUserAlert } from "../utils/userErrorMessage";
// src/pages/DriverAdd.jsx
import React, { useState } from "react";
import Header from "../Component/Header";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { supabase } from "../supabase/client"; // ✅ 추가: supabase client
import { syncCarFromDriverProfile } from "../utils/driverCarSync";

export default function DriverAdd() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    email: "",
    driver_name: "",
    hire_date: "",
    car_number: "", // optional
    phone: "", // ✅ 기사 전화번호
    career: "", // ✅ 경력사항
  });

  const company = localStorage.getItem("email") || "";
  const companyName = localStorage.getItem("companyName") || company;

  const handleChange = (field, value) => {
    setForm((p) => ({ ...p, [field]: value }));
  };

  const handleSubmit = async () => {
    if (saving) return;

    const email = (form.email || "").trim();
    const phone = (form.phone || "").trim();
    const driverName = (form.driver_name || "").trim();

    if (!driverName) return showUserAlert("기사명을 입력하세요.");
    if (!phone) return showUserAlert("기사 전화번호를 입력하세요.");
    if (email && !/\S+@\S+\.\S+/.test(email)) return showUserAlert("올바른 이메일 형식을 입력하세요.");

    setSaving(true);
    try {
        const { data, error } = await supabase.functions.invoke("create-driver", {
        body: {
            email: email || null,
            driver_name: driverName,
            hire_date: form.hire_date || null,
            car_number: form.car_number || null,
            phone,
            career: form.career || null,
            company,
            company_name: companyName,
        },
        });

        if (error) {
            // supabase-js가 4xx/5xx면 여기로 옴
            let msg = error.message || "Edge Function returned a non-2xx status code";
            const status = error?.status || error?.context?.status;

            if (status === 409) {
              showUserAlert("이미 등록된 기사(이메일/전화번호)입니다. 목록에서 확인하거나 수정 기능을 이용하세요.");
              return;
            }
            try {
                const parsed = JSON.parse(error.message);
                if (parsed?.error) {
                msg = parsed.error + (parsed.stage ? ` (stage: ${parsed.stage})` : "");
                }
            } catch {}
            throw new Error(msg);
        }

        if (data?.error) {
            const msg = data.error + (data.stage ? ` (stage: ${data.stage})` : "");
            throw new Error(msg);
        }

        await syncCarFromDriverProfile(supabase, {
          company,
          previousCarNumber: "",
          previousEmail: "",
          previousDriverName: "",
          nextCarNumber: form.car_number,
          driverName,
          phone,
          email,
        });

        showUserAlert(
            `기사 계정이 생성/갱신되었습니다.
            로그인 아이디: ${email || phone}
            초기 비밀번호: ${data?.initialPassword || "asdfasdf"}`
            );
        navigate("/drivers");
    } catch (e) {
        showUserAlert("등록 실패: " + (e?.message || "알 수 없는 오류"));
    } finally {
        setSaving(false);
    }
    };


  return (
    <div className="space-y-1">
      <Header />
      <div className="px-4 pt-1 pb-4 space-y-2">
        <h2 className="text-lg font-semibold">기사 추가</h2>

        <Card className="p-2">
          <CardContent className="bg-white">
            <div className="reservation-form-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="reservation-section-title">기본 정보</div>
              {/* 회사 (읽기전용) */}
              <div>
                <label className="block font-semibold mb-1">회사(저장값)</label>
                <Input value={companyName} disabled />
                <p className="text-xs text-gray-500 mt-1">
                  ※ 내부 식별값은 로그인 이메일로 별도 저장됩니다.
                </p>
              </div>

              {/* 역할 (고정 driver) */}
              <div>
                <label className="block font-semibold mb-1">역할</label>
                <Input value="driver" disabled />
              </div>

              <div className="reservation-section-title">기사 정보</div>
              {/* 기사 이메일 */}
              <div>
                <label className="block font-semibold mb-1">기사 이메일</label>
                <Input
                  value={form.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                  placeholder="선택 입력"
                  disabled={saving}
                />
              </div>

              {/* 기사명 */}
              <div>
                <label className="block font-semibold mb-1">기사명</label>
                <Input
                  value={form.driver_name}
                  onChange={(e) => handleChange("driver_name", e.target.value)}
                  placeholder="홍길동"
                  disabled={saving}
                />
              </div>
              <div>
                <label className="block font-semibold mb-1">입사일</label>
                <Input
                  type="date"
                  value={form.hire_date || ""}
                  onChange={(e) => handleChange("hire_date", e.target.value)}
                  disabled={saving}
                />
              </div>
                {/* 기사 전화번호 */}
              <div>
                <label className="block font-semibold mb-1">기사 전화번호</label>
                <Input
                    value={form.phone}
                    onChange={(e) => handleChange("phone", e.target.value)}
                    placeholder="01012345678"
                    disabled={saving}
                />
              </div>

              {/* 차량번호 (선택) */}
              <div>
                <label className="block font-semibold mb-1">차량 번호 (선택)</label>
                <Input
                  value={form.car_number}
                  onChange={(e) => handleChange("car_number", e.target.value)}
                  placeholder="12가3456"
                  disabled={saving}
                />
              </div>
              <div className="reservation-section-title">경력사항</div>

              {/* 경력사항 */}
              <div className="md:col-span-2 lg:col-span-3">
                <label className="block font-semibold mb-1">경력사항</label>
                <textarea
                  className="w-full border border-gray-300 rounded px-3 py-2 h-24"
                  placeholder="경력사항 입력"
                  value={form.career || ""}
                  onChange={(e) => handleChange("career", e.target.value)}
                  disabled={saving}
                />
              </div>

              <div className="reservation-action-row">
              <Button onClick={handleSubmit} disabled={saving}>
                {saving ? "등록중..." : "등록"}
              </Button>
              <Button variant="outline" onClick={() => navigate("/drivers")} disabled={saving}>
                돌아가기
              </Button>
            </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
